import { usePermissionsRepository } from '@Hooks/useRepository';
import { UsersRepository } from '@Repositories/Permissions';
import { useToasts } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useUnblockUser = (userId: string, onMutate: () => void) => {
    const users = usePermissionsRepository(UsersRepository);
    const { pushAllToasts } = useToasts();

    const { mutateAsync, isPending: unblockUserIsPending } = useMutation({
        mutationFn: () => users.unblockUser(userId),
    });

    const unblockUserHandler = useCallback(async () => {
        const result = await mutateAsync();
        pushAllToasts(result.messages);
        onMutate();
    }, [mutateAsync, pushAllToasts, onMutate]);

    return { unblockUserHandler, unblockUserIsPending };
};
